import PropTypes from "prop-types";

function ForceRedirect({ uri }) {
  if (uri) {
    window.location.href = uri;
  }
  return null;
}

ForceRedirect.propTypes = {
  uri: PropTypes.string.isRequired,
};

export default ForceRedirect;
